'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _components = require('../../components');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _Crown = require('./Crown');

var _Crown2 = _interopRequireDefault(_Crown);

var _reactFontawesome = require('@fortawesome/react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _Login = require('./Login/Login');

var _Login2 = _interopRequireDefault(_Login);

var _Navigation = require('./Navigation/Navigation');

var _Navigation2 = _interopRequireDefault(_Navigation);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Header = require('./Header.scss');

var _Header2 = _interopRequireDefault(_Header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function (_Component) {
    (0, _inherits3.default)(Header, _Component);

    function Header(props, context) {
        (0, _classCallCheck3.default)(this, Header);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).call(this, props, context));

        _this.toggleShowSearch = function () {
            _this.setState({ showSearch: !_this.state.showSearch });
        };

        _this.state = {
            showSearch: false
        };
        return _this;
    }

    (0, _createClass3.default)(Header, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['location', 'logo', 'mobile', 'userLoggedIn', 'whiteLabel', 'windowWidth']) || (0, _propsComparer2.default)(this.state, nextState, ['showSearch']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseUrl = _props.baseUrl,
                location = _props.location,
                logo = _props.logo,
                logOutBidder = _props.logOutBidder,
                mobile = _props.mobile,
                openCreateAccountModal = _props.openCreateAccountModal,
                openLoginModal = _props.openLoginModal,
                userLoggedIn = _props.userLoggedIn,
                whiteLabel = _props.whiteLabel,
                windowWidth = _props.windowWidth;
            var showSearch = this.state.showSearch;


            var headerLogo = logo;

            var searchBarDesktop = 'search-bar-desktop';
            var searchBarMobile = 'search-bar-mobile';

            return (0, _jsx3.default)('div', {
                className: _Header2.default.header
            }, void 0, (0, _jsx3.default)(_Crown2.default, {
                location: location,
                whiteLabel: whiteLabel
            }), (0, _jsx3.default)('div', {
                className: '' + _Header2.default.wrapper + (whiteLabel ? ' ' + _Header2.default['white-label'] : '')
            }, void 0, (0, _jsx3.default)('div', {
                className: _Header2.default['search-bar']
            }, void 0, (0, _jsx3.default)('div', {
                className: _Header2.default['image-container']
            }, void 0, (0, _jsx3.default)(_components.Link, {
                className: _Header2.default['header-logo-link'],
                route: true,
                to: '/'
            }, void 0, headerLogo && (0, _jsx3.default)('img', {
                className: _Header2.default['header-logo'],
                src: headerLogo
            }))), (0, _jsx3.default)('div', {
                className: _Header2.default['search-field-container']
            }, void 0, (0, _jsx3.default)(_components.SearchInput, {
                name: searchBarDesktop
            })), (0, _jsx3.default)('div', {
                className: _Header2.default['search-button-container']
            }, void 0, (0, _jsx3.default)(_reactFontawesome2.default, {
                className: _Header2.default['search-field-icon'],
                icon: ['fas', 'search'],
                onClick: this.toggleShowSearch
            })), (0, _jsx3.default)('div', {
                className: _Header2.default['controls-container']
            }, void 0, (0, _jsx3.default)(_Login2.default, {
                baseUrl: baseUrl,
                logOutBidder: logOutBidder,
                mobile: mobile,
                openCreateAccountModal: openCreateAccountModal,
                openLoginModal: openLoginModal,
                parent: this,
                userLoggedIn: userLoggedIn,
                whiteLabel: whiteLabel,
                windowWidth: windowWidth
            }))), (0, _jsx3.default)('div', {
                className: _Header2.default['mobile-search'] + ' ' + (showSearch ? _Header2.default.show : '')
            }, void 0, (0, _jsx3.default)(_components.SearchInput, {
                name: searchBarMobile
            }))), !whiteLabel && (0, _jsx3.default)(_Navigation2.default, {
                mobile: mobile,
                parent: this
            }));
        }
    }]);
    return Header;
}(_react.Component);

exports.default = Header;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Header.js
// module id = IE5j
// module chunks = 57